// extracted by mini-css-extract-plugin
module.exports = {"section":"tableWithContext_section__iXVoe","tableWrapper":"tableWithContext_tableWrapper__gfaBB","disclaimer":"tableWithContext_disclaimer__SIb_6"};